import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

import * as colors from "~/theme/colors";

export const CopyrightContainer = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "center",
  background: colors.COLOR_PRIMARY_BLACK,
  color: colors.COLOR_PRIMARY_WHITE,
  padding: 14,
}));
